import { Component, Input } from '@angular/core';
import { Patient } from 'app/core/models/patient.model';
import { RouterLinkActive, RouterLink } from '@angular/router';

@Component({
    selector: 'app-patient-nav',
    templateUrl: './patient-nav.component.html',
    styleUrls: ['./patient-nav.component.scss'],
    imports: [RouterLinkActive, RouterLink]
})
export class PatientNavComponent {
  @Input() patient: Patient;
 }
